export const MESSAGE_MAX_LENGTH = 1600;

export const MESSAGE_INPUT_LIMIT_ERROR =
    'Message is at the character limit. Shorten it before adding more.';
